import React from 'react';
import { Table } from 'semantic-ui-react';

import { useSelector } from 'react-redux';
import { SprayEventDisposal } from 'services/sprayEvents/types';
import DateTableHeaderCell from '../DateTableHeaderCell';
import AreaTableHeaderCell from '../AreaTableHeaderCell';
import SelectableTableHeaderCell from '../SelectableTableHeaderCell';
import { selectDisposalFields } from './selectors';
import ApplyAllFormSpy from '../ApplyAllFormSpy';

const DisposalTableHeader = (): React.ReactElement => {
    const fields = useSelector(selectDisposalFields);

    return (
        <Table.Header className="complete-spray-event-form-table-header">
            <Table.Row>
                <ApplyAllFormSpy
                    fields={fields}
                    applyAllFieldName="disposalApplyAll"
                />
                <DateTableHeaderCell />
                <AreaTableHeaderCell />
                <SelectableTableHeaderCell
                    name="disposalApplyAll"
                    value={SprayEventDisposal.TARGET_CORP}
                    title="Target corp"
                    fields={fields}
                    defaultValue={SprayEventDisposal.TARGET_CORP}
                    medium
                />
                <SelectableTableHeaderCell
                    name="disposalApplyAll"
                    value={SprayEventDisposal.SHELTER_BELT}
                    title="Shelter belt"
                    fields={fields}
                    medium
                />
                <SelectableTableHeaderCell
                    name="disposalApplyAll"
                    value={SprayEventDisposal.HEADLAND}
                    title="Headland"
                    fields={fields}
                    medium
                />
                <SelectableTableHeaderCell
                    name="disposalApplyAll"
                    value={SprayEventDisposal.FALLOW_LAND}
                    title="Fallow land"
                    fields={fields}
                    medium
                />
                <SelectableTableHeaderCell
                    name="disposalApplyAll"
                    value={SprayEventDisposal.OTHER}
                    title="Other"
                    fields={fields}
                    medium
                />
            </Table.Row>
        </Table.Header>
    );
};

export default DisposalTableHeader;
